const dictionary = {
  pt: {
    messages: {
      required: "Preenchimento obrigatório",
      min: (field, args) => {
        switch (field) {
          case "cpf":
            return "CPF deve conter 11 dígitos.";
          case "cnpj":
            return "CNPJ deve conter 14 dígitos.";
          case "postcode":
            return "CEP deve conter 8 dígitos.";
          case "phone_main":
            return "Telefone inválido";
          case "phone_secondary":
            return "Telefone inválido";
          default:
            return `Mínimo ${args[0]} caracteres`;
        }
      },
      email: "Email inválido. Por favor, verifique novamente.",
      cpf: "CPF inválido. Por favor, verifique novamente.",
      cnpj: "CNPJ inválido. Por favor, verifique novamente.",
      date: "Data inválida. Por favor, verifique novamente.",
      confirmed: (field, arg) => {
        switch (field) {
          case "password_confirmation":
            return "Senha e confirmação não coincidem.";
          default:
            return `${arg[0]} e ${field} não coincidem.`;
        }
      }
    }
  }
};

export default dictionary;
